<template>
    <div class="mt-4">
        <b-row>
            <b-col col lg="6" md="6" sm="12">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Last Name">
                    <b-form-input data-vv-name="last_name" v-validate="'required|alpha_spaces'" data-vv-as="Last Name"
                                  name="last_name"
                                  v-model="personal_info.last_name"></b-form-input>
                    <span class="error">{{ errors.first('last_name') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="First Name">
                    <b-form-input v-validate="'required|alpha_spaces'" data-vv-as="First Name" name="first_name"
                                  v-model="personal_info.first_name"></b-form-input>
                    <span class="error">{{ errors.first('first_name') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Middle Name">
                    <b-form-input v-validate="'required'" data-vv-as="Middle Name" name="middle_name"
                                  v-model="personal_info.middle_name"></b-form-input>
                    <span class="error">{{ errors.first('middle_name') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Gender">
                    <b-form-radio-group v-validate="'required'" class="mt-2" v-model="personal_info.gender"
                                        name="gender">
                        <b-form-radio value="female">Female</b-form-radio>
                        <b-form-radio value="male">Male</b-form-radio>
                    </b-form-radio-group>
                    <span class="error">{{ errors.first('gender') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Marital Status">
                    <b-form-radio-group v-validate="'required'" class="mt-2" v-model="personal_info.civil_status" name="civil_status">
                        <b-form-radio value="single">Single</b-form-radio>
                        <b-form-radio value="married">Married</b-form-radio>
                    </b-form-radio-group>
                    <span class="error">{{ errors.first('civil_status') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Date of Birth">
                    <datepicker format="yyyy-MM-dd" v-model="personal_info.birth_date"
                                :value="personal_info.birth_date" input-class="form-control"></datepicker>
                    <span class="error">{{ errors.first('birthdate') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Birth Place">
                    <b-form-textarea row="3" v-model="personal_info.birth_place"></b-form-textarea>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Age">
                    <b-input-group :append="age_type">
                        <b-form-input v-validate="'required'" name="age" readonly
                                      v-model="personal_info.age"></b-form-input>
                    </b-input-group>
                    <span class="error">{{ errors.first('age') }}</span>
                </b-form-group>
            </b-col>
            <b-col col lg="6" md="6" sm="12">
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Occupation">
                    <b-form-input v-model="personal_info.occupation"></b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Nationality">
                    <b-form-input v-model="personal_info.nationality"></b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Identifiers">
                    <b-form-input v-model="personal_info.identifiers"></b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Religion">
                    <b-form-input v-model="personal_info.religion"></b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Address">
                    <b-form-textarea :rows="3" v-validate="'required'" name="address"
                                     v-model="personal_info.address"></b-form-textarea>
                    <span class="error">{{ errors.first('address') }}</span>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Home Phone #">
                    <b-form-input v-model="personal_info.phone"></b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Mobile #">
                    <b-form-input v-model="personal_info.mobile"></b-form-input>
                </b-form-group>
                <b-form-group
                        horizontal
                        :label-cols="3"
                        breakpoint="lg"
                        label="Email">
                    <b-form-input v-validate="'email'" v-model="personal_info.email"></b-form-input>
                    <span class="error">{{ errors.first('email') }}</span>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  // Utils
  import moment from 'moment';
  import {cloneDeep} from 'lodash';

  import Datepicker from 'vuejs-datepicker';

  export default {
    inject: ['$validator'],
    props: {
      mode: {
        type: String,
        default: 'add'
      },
      patient: {
        type: Object,
        default: null
      }
    },

    components: {
      Datepicker
    },

    data() {
      return {
        personal_info: {},
        age_type: 'years'
      }
    },

    computed: {
      birth_date() {
        return this.personal_info.birth_date || null;
      }
    },

    created() {
      if (this.mode === 'edit') {
        this.personal_info = cloneDeep(this.patient);
      }
    },

    watch: {
      birth_date(val) {
        if (moment(val, 'YYYY-MM-DD', true).isValid()) {
          const ageTypes = ['years', 'months', 'days'];
          for (let type of ageTypes) {
            let age = moment().diff(val, type, true);
            if (age < 1) continue;
            this.personal_info.age = Math.floor(age);
            this.age_type = type;
            break;
          }
        } else {
          this.personal_info.age = null;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Form/PersonalInformationForm.vue